import type { IconProps } from '../types';

const Share = (props: IconProps) => (
  <svg
    fill="#7A7A98"
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path d="M27.89 16.3a.48.48 0 0 0 0-.62l-8.38-9.55a.34.34 0 0 0-.42-.1.45.45 0 0 0-.23.41v5.2c-.6-.04-1.2-.04-1.8-.01-3.86.17-7.29 1.65-9.63 4.2A12.4 12.4 0 0 0 4.92 20 15.95 15.95 0 0 0 4 25.56c0 .2.12.38.29.43.16.05.34-.04.42-.22l.1-.21v-.01A14.23 14.23 0 0 1 5.9 23.7a7.9 7.9 0 0 1 4.22-3.08c2.32-.73 5.3-.7 8.74-.66v5.57c0 .18.1.34.23.4.15.08.3.04.42-.09l8.38-9.55Zm-7.23 5.36 5.06-5.67-5.06-5.66v3.34l-1.9-.11c-4.17-.25-7.78 1.14-10.05 3.62-.78.85-1.43 1.86-1.91 3a9.78 9.78 0 0 1 2.82-1.4m11.04 2.88v-3.58l-1.77-.03c-3.36-.05-6.65-.09-9.27.74" />
  </svg>
);

export default Share;
